import * as graphs from './graphs';

console.log('graphs', graphs);

function getPeriodString(startDate, endDate) {
  var monthNames = [
    "Jan", "Feb", "Mar",
    "Apr", "May", "Jun",
    "Jul", "Aug", "Sep",
    "Oct", "Nov", "Dec"
  ];

  // Get the month and day from the Date object
  var startMonth = monthNames[startDate.getMonth()];
  var startDay = startDate.getDate();

  var endMonth = monthNames[endDate.getMonth()];
  var endDay = endDate.getDate();

  // Combine the month and day into the desired format
  return `${startMonth} ${startDay} - ${endMonth} ${endDay}`;
}
export function getPeriod(deal) {
  if (deal?.content?.baseType === 'evergreen') {
    return {}
  } else {
    const periodEnd = new Date(new Date().toUTCString())
    periodEnd.setDate(periodEnd.getDate() + Number(deal?.content?.dueInDays || 0) + (deal?.content?.delayOnAccept ? Number(deal?.content?.delayStartDays || 0) : 0))
    console.log('setting to', periodEnd.getDate() + Number(deal?.content?.dueInDays || 0) + (deal?.content?.delayOnAccept ? Number(deal?.content?.delayStartDays || 0) : 0))
    // set deal period
    const periodStart = new Date(new Date().toUTCString())
    if (deal?.content?.delayOnAccept) {
      periodStart.setDate(periodStart.getDate() + Number(deal?.content?.delayStartDays))
    }
    const periodString = getPeriodString(periodStart, periodEnd)
    return {
      start: periodStart.toUTCString(),
      end: periodEnd.toUTCString(),
      endTimestamp: periodEnd,
      periodString
    }
  }
}

function getFlagEmoji(countryCode) {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => 127397 + char.charCodeAt());
  return String.fromCodePoint(...codePoints);
}

export function replaceTemplateVars({ string, deal, store, affiliateFields, forms, creatorName, creatorID, user }) {

  const defaultForm = forms?.find(f => f.basicInfo?.isDefault)

  const evergreenStrings = []
  const contentStrings = (deal?.content?.formats)?.map((fmt) => {
    const key = Object.keys(fmt)[0]
    const value = fmt[key]
    evergreenStrings.push(`<p>- ${key}(s)</p>`)
    return `<p>- ${key}(s): x${value}</p>`
  }
  )?.join('')

  let newString = string.replaceAll('{firstName}', creatorName?.split(' ')?.[0] || creatorName)
    .replaceAll('{portalLink}', `<a href="https://${store?.customDomain}.partnerup.net">Portal Link</a>`)
    .replaceAll('{storeName}', store?.name)
    .replaceAll('{fromName}', user?.signature || user?.name)
    .replaceAll('{signature}', user?.signature || user?.name)

  if (defaultForm) {
    let formURL = `https://${store?.customDomain}.partnerup.net/o/?id=${defaultForm.id}`
    if (creatorID) {
      formURL = formURL + `&c=${creatorID}`
    }
    newString = newString.replaceAll('{onboardingLink}', `<a href="${formURL}">Onboarding Form Link</a>`)
  }

  if (deal?.id) {
    newString = newString.replaceAll('{campaignName}', deal?.publicTitle)
      .replaceAll('{campaignLink}', `<a href="https://${store?.customDomain}.partnerup.net/c/?id=${deal?.id}">Offer Link</a>`)
  } else {
    newString = newString.replaceAll('{campaignName}', deal?.publicTitle)
      .replaceAll('{campaignLink}', `<p>Offer Link</p>`)
  }

  newString = newString.replaceAll('{campaignDetails}', `{contentDetails}{paymentDetails}{productDetails}`)

  let contentString = ''
  if (deal?.content?.baseType === 'fixed' || deal?.content?.baseType === 'recurring') {
    contentString = `<p><b>Content Details</b></p>
  <p>Deliverables:</p>
  ${contentStrings}
  <p>Due:</p><p>${deal?.content?.baseType === 'fixed' ? 'In' : 'Every'} ${deal?.content?.dueInDays} days</p>
<br>
`
  } else if (deal?.content?.baseType === 'evergreen') {
    contentString = `<p><b>Content Details</b></p>
<p>
  <p>Evergreen, create as many as you want of</p>
  ${evergreenStrings.join('')}
</p>
<br>
`
  }
  newString = newString.replaceAll('{contentDetails}', contentString)

  let paymentString = ''
  if (affiliateFields?.code) {
    paymentString = `<p>Your Affiliate Code: ${affiliateFields.code}</p>
<p>Your Affiliate Link: <a href="https://${store?.customDomain}.prup.io/${affiliateFields.code}">https://${store?.customDomain}.prup.io/${affiliateFields.code}</a></p>
<p>Commission: ${deal?.affiliateFields?.commission}% | Discount: ${deal?.affiliateFields?.discountType === 'percentage' ? `${deal?.affiliateFields?.discountPercentage}% Off` : deal?.affiliateFields?.discountType === 'freeShipping' ? 'Free Shipping' : `$${deal?.affiliateFields?.discountFixedValue} Off`}</p>
<br>
`
  } else {
    paymentString = `<p><b>Affiliate Details</b></p>
<p>Commission: ${deal?.affiliateFields?.commission}%</p>
<p>Discount: ${deal?.affiliateFields?.discountType === 'percentage' ? `${deal?.affiliateFields?.discountPercentage}% Off` : deal?.affiliateFields?.discountType === 'freeShipping' ? 'Free Shipping' : `$${deal?.affiliateFields?.discountFixedValue} Off`}</p>
<br>
`
  }
  if (deal?.payments?.includePayment && deal?.payments?.price) {
    paymentString = paymentString + `<p>Your Fixed Payment: $${deal.payments.price}</p><p>${deal.payments.whenPayment}</p>`
  }
  newString = newString.replaceAll('{paymentDetails}', paymentString)

  let productsString = ''
  if (deal?.products?.choice === 'Fixed Product Set' && deal?.products?.selectedVariants?.length) {
    productsString = `<p><b>Products</b></p>
<p>You'll Receive ${deal?.products?.selectedVariants?.length} Free Products</p><br>
`
    newString = newString.replaceAll('{productDetails}', productsString)
  } else if (deal?.products?.choice === 'Creator Can Choose' && deal?.products?.selectedVariants?.length) {
    productsString = `<p><b>Products</b></p>
<p>You can choose ${deal?.products?.maxProductQuantity} Free Products</p> 
<p>Up to $${deal?.products?.maxProductValue} in value</p>
<br>
`
    newString = newString.replaceAll('{productDetails}', productsString)
  }

  return newString
}
export const graphColorCodes = [
  'rgba(76, 175, 80, 1)',   // Green
  'rgba(255, 87, 51, 1)',   // Red-Orange
  'rgba(255, 195, 0, 1)',   // Yellow
  'rgba(33, 150, 243, 1)',  // Blue
  'rgba(155, 89, 182, 1)',  // Purple
  'rgba(233, 30, 99, 1)',   // Pink
  'rgba(0, 188, 212, 1)',   // Cyan
  'rgba(139, 195, 74, 1)',  // Lime
  'rgba(255, 152, 0, 1)',   // Orange
  'rgba(121, 85, 72, 1)'    // Brown
];

export function getCountry(country, flagOnly) {
  if (!country) return country;
  return `${getFlagEmoji(country)} ${flagOnly ? '' : country.toUpperCase()}`;
}

export function shortenNumber(number) {
  if (!number || typeof number !== 'number' || number < 1000) return Math.floor(number || 0)
  return (number > 1000000) ? (number / 1000000)?.toFixed(2) + 'M' : Math.floor(number / 1000) + 'K'
}


export function getBestAvatar(creator) {
  if (!creator) return null
  return creator?.profile?.profile?.picture
}

export function timeAgo(timestamp) {

  const date = new Date(timestamp)?.getTime();
  var seconds = Math.floor((new Date() - date) / 1000);

  var interval = seconds / 31536000;

  if (interval >= 1) {
    return Math.floor(interval) + " year" + (Math.floor(interval) > 1 ? 's' : '') + " ago";
  }
  interval = seconds / 2592000;
  if (interval >= 1) {
    return Math.floor(interval) + " month" + (Math.floor(interval) > 1 ? 's' : '') + " ago";
  }
  interval = seconds / 86400;
  if (interval >= 1) {
    return Math.floor(interval) + " day" + (Math.floor(interval) > 1 ? 's' : '') + " ago";
  }
  interval = seconds / 3600;
  if (interval >= 1) {
    return Math.floor(interval) + " hour" + (Math.floor(interval) > 1 ? 's' : '') + " ago";
  }
  interval = seconds / 60;
  if (interval >= 1) {
    return Math.floor(interval) + " minute" + (Math.floor(interval) > 1 ? 's' : '') + " ago";
  }
  return Math.floor(seconds) + " seconds ago";
}

export function copyToClipboard(url, setToast) {
  try {
    navigator.clipboard.writeText(url)
    if (setToast) {
      setToast({ content: 'Copied to clipboard', type: 'success' })
    }
  } catch (e) {
    if (setToast) {
      setToast({ content: 'Failed to copy to clipboard', type: 'error' })
    }
  }
}

export function getCreatorAffiliatePaymentSummary(creatorID, allCodes, inPay) {
  const creatorCodes = allCodes.filter(code => code.creatorID === creatorID)
  const affiliatePaymentSummary = {
    salesValue: 0,
    amountDue: 0,
    amountPaid: 0,
    amountPending: 0,
    orderCount: 0,
    orders: [],
    pendingOrders: [],
    pendingValue: 0,
  }
  creatorCodes.forEach(code => {
    if (code?.orders?.length) {
      console.log('code is', code?.id, code)
      console.log('creatorID', creatorID, 'inPay', inPay)
      code.orders.forEach(order => {
        const salesValue = Number(order?.subtotalPriceSet?.shopMoney?.amount || 0);
        const amountDue = (salesValue * code.commission / 100) || 0
        if (order?.commissionPaid) {
          affiliatePaymentSummary.amountPaid += amountDue
          return affiliatePaymentSummary
        }

        console.log('order', order)
        affiliatePaymentSummary.amountPending += amountDue
        affiliatePaymentSummary.pendingOrders.push({
          id: order.name,
          orderID: order.id,
          codeID: code.id,
          commissionPayment: amountDue,
        })
        affiliatePaymentSummary.pendingValue += salesValue
        if (order?.paymentDue) {
          affiliatePaymentSummary.amountDue += amountDue
          affiliatePaymentSummary.orderCount += 1
          affiliatePaymentSummary.orders.push({
            id: order.name,
            orderID: order.id,
            codeID: code.id,
            commissionPayment: amountDue,
          })
          affiliatePaymentSummary.salesValue += salesValue
        } else {
        }
      })
      console.log('summary is', affiliatePaymentSummary)
    }
  })
  return affiliatePaymentSummary
}
export function fixedDealHasNewPosts(deal, dealPosts) {
  if (deal?.status === 'active' && (deal?.content?.baseType === 'fixed' || deal?.content?.baseType === 'recurring') && dealPosts?.length) {
    return dealPosts?.filter(post => !post?.paid)?.length
  }
}
export function dealNeedsAffiliateCode(deal, allCodes) {
  return deal?.status === 'active' && deal.payments?.includeAffiliate && !getDealAffiliateCode(deal, allCodes)
}

export function dealHasOverdueContent(deal) {
  return deal?.status === 'active' && deal?.content?.baseType !== 'evergreen' && (!deal?.periodPaid) && new Date(deal?.period?.end) < new Date();
}

export function dealNeedsContentReview(deal, dealReviewContent) {
  return deal?.status === 'active' && (dealReviewContent?.length);
}

export function dealApplicationNeedsReview(deal) {
  return deal?.status === 'formSubmitted'
}

export function fixedDealIsComplete(deal, pastPayments) {
  return deal?.periodPaid
    && deal?.status === 'active'
    && deal?.content?.baseType === 'fixed'
    && (
      !deal?.payments?.price
      || pastPayments?.find(p => p.dealID === deal?.id && p.paymentType === 'fixed') //&& p.period?.periodString === creatorActiveDeal.period?.periodString)
    )
}

export function getDealAffiliateCode(deal, allCodes) {
  if (!allCodes || !deal) return null
  return allCodes.find(code => {
    return (code.dealID === deal.id) && code.isActiveCode
  })
}

export function dealHasTodos(deal, allCodes, allContent = []) {
  return (
    dealNeedsAffiliateCode(deal, allCodes)
    // || dealNeedsSampleOrder(deal)
    || dealApplicationNeedsReview(deal, allCodes)
    || dealNeedsContentReview(deal)
    || getRequiresPayment(deal, allContent)
  )
}

export function getPaymentDueSummary(deal, allContent) {
  const content = allContent?.filter(c => c.dealID === deal?.id)
  const paymentDueSummary = {
    amountDue: 0,
    contentCount: 0,
    contentIDs: []
  };

  const unpaidContent = content?.filter(c => !c?.paid)

  if (unpaidContent?.length && Number(deal?.payments?.price)) {
    if (deal?.content?.baseType === 'evergreen' || deal?.content?.baseType === 'recurring') {
      paymentDueSummary.amountDue = Number(deal?.payments?.price) * unpaidContent.length
      paymentDueSummary.contentIDs = unpaidContent.map(c => c.id)
      paymentDueSummary.contentCount = unpaidContent.length
    } else if (deal?.content?.baseType === 'fixed') {
      const contentCount = (deal?.content?.formats || []).reduce((acc, obj) => {
        const key = Object.keys(obj)[0]
        if (key) acc += obj[key]
        return acc
      }, 0) || 0
      if (unpaidContent?.length >= contentCount) {
        paymentDueSummary.amountDue = Number(deal?.payments?.price)
        paymentDueSummary.contentIDs = unpaidContent.map(c => c.id)
        paymentDueSummary.contentCount = contentCount
      }
    }
  }

  return paymentDueSummary
}

export function getRequiresPayment(deal, allContent) {
  return getPaymentDueSummary(deal, allContent).amountDue > 0
}
export function getRequiresAffiliatePayment(deal, allCodes) {
  return getDealAffiliatePaymentSummary(deal, allCodes).amountDue > 0
}

export function getDealAffiliatePaymentSummary(deal, allCodes) {
  const dealCodes = allCodes.filter(code => code.dealID === deal.id)
  const affiliatePaymentSummary = {
    salesValue: 0,
    amountDue: 0,
    orderCount: 0,
    orders: [],
  }
  if (dealCodes.length) {
    dealCodes.forEach(code => {
      if (code?.orders?.length) {
        code.orders.filter(order => !order.commissionPaid && order.paymentDue).forEach(order => {
          const salesValue = Number(order?.subtotalPriceSet?.shopMoney?.amount || 0);
          const amountDue = (salesValue * code.commission / 100) || 0
          affiliatePaymentSummary.salesValue += salesValue
          affiliatePaymentSummary.amountDue += amountDue
          affiliatePaymentSummary.orderCount += 1
          affiliatePaymentSummary.orders.push({
            orderID: order.id,
            codeID: code.id,
          })
        })
      }
    })
  }
  return affiliatePaymentSummary
}

export function getMonthDayString(currentDate) {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  return `${monthNames[currentDate.getMonth()]} ${currentDate.getDate().toString().padStart(2, '0')}`
}

export function getDaysBetweenDates(startDate, endDate) {
  // Copy the start date
  let currentDate = new Date(startDate);
  // Initialize an empty array to store the days
  let days = [];

  while (currentDate <= endDate) {
    let dateString = getMonthDayString(currentDate);
    days.push(dateString);
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return days;
}

export function numberToUSD(number, currency = 'USD', decimals = 2) {
  if (!number) number = 0
  return Number(number).toLocaleString('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals
  })
}

export function daysAgo(date) {
  const today = new Date(); // Get current date
  const pastDate = new Date(date); // Convert input date string to a Date object
  const timeDifference = today.getTime() - pastDate.getTime(); // Difference in milliseconds
  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
  return daysDifference;
}

export default { ...graphs };
